module.exports = __webpack_public_path__ + "static/media/DSC00248.f36f03c7.jpg";